require('./sidebar-cart');
require('./register');
require('./login');
require('./forgot');
require('./account');
require('./addresses');
require('./companies');
require('./shopping-cart');
require('./ratings');
require('./coupons');
require('./order');
require('./newsletter');
require('./filters');
require('./search');
require('./wishlist');
require('./order-guest');
require('./contact');
require('./slider');
require('./products');
require('./points');
require('./testimonials');
require('./cookies');
require('./gift-boxes');



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js